import { useMutation, useQuery, useQueryClient } from "react-query";
import { getIntegrationUsage, syncIntegrationUsages, deleteIntegrationCode } from "@/api/Histories/integration-api";

const key = "io_integration";

export function useIntegrationUsage(params, options = {}) {
	return useQuery([key, params], () => getIntegrationUsage(params), {
		enabled: !!params,
		...options,
	});
}

export function useSyncIntegration(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation((payload) => syncIntegrationUsages(payload), {
		onSuccess: (response) => {
			if (response?.updated_data && listType && filters) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}

			queryClient.invalidateQueries([key]);
		},
	});
}

export function useDeleteIntegrationCode(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation((payload) => deleteIntegrationCode(payload), {
		onSuccess: (response) => {
			if (response?.updated_data && listType && filters) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}

			queryClient.invalidateQueries([key]);
		},
	});
}
